import { Container } from "react-bootstrap";
import PremierSuites from "../assets/others/PREMIER SUITES Reading.jpg"

import { useEffect } from "react";



function VisitPrimer() {


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (

    <div>
      <Container fluid className="pageContainer">
        <div className="pageTitleDiv">VISIT READING</div>
        <Container fluid className="pageImageContainer">

        </Container>


          <div className="sectionDiv" style={{textAlign:"justify", margin:"20px 20px 10px 20px"}}>
            <h1 style={{ marginBottom: "20px" }}>PREMIER SUITES Reading</h1>
            <h5>
             <strong>PREMIER SUITES Reading</strong> is our preferred accommodation provider, offering quality service and convenient access to everything Reading has to offer.

              Located in the heart of Reading, PREMIER SUITES Reading's modern serviced apartments are the perfect choice for a business or leisure stay.

             
              Guests can also enjoy a  10% discount by visiting  <a href="https://www.premiersuiteseurope.com/en/locations/united-kingdom/reading/serviced-apartments-reading" target="_blank" rel="noopener noreferrer">www.premiersuitesreading.com</a>, quoting RCS10 in the discount box, or by contacting
              Sales Manager Laura Grantham.


            </h5>
            <p></p>
            <img src={PremierSuites} alt="PREMIER SUITES Reading" style={{ display: 'block',margin: "0 auto", width: '90%', height: 'auto' }} />




          </div>


 
      </Container>
    </div>
  );
}

export default VisitPrimer;
